import React from 'react';
import MaintenancePage from './components/MaintenancePage';

function App() {
  return (
    <div className="App">
      <MaintenancePage />
    </div>
  );
}

export default App;